export default __webpack_public_path__ + "static/media/Inter-SemiBold.45b4c2ae.ttf";